module.exports = __webpack_public_path__ + "static/media/platform-background.c44f00eb.webp";